export default "__VITE_ASSET__P6uoPNVl__"